import { useConfig } from '../../hooks/UseConfig';

export type parameters = {
  [key: string]: string;
};

export enum ApiMethodsType {
  Conquest = `/conquest`,
  // TotalOffers = `/Offers`,
  // Dealers = `/Dealers`
}

export const GetApiUrl = (name: keyof typeof ApiMethodsType): string => {
  const method = ApiMethodsType[name];
  const { apiUrl } = useConfig();
  return apiUrl + method;
};

export const GetApiUrlFromPath = (path: string): string => {
  const { apiUrl } = useConfig();
  return apiUrl + path;
};

export const BuildPathFromParameters = (path: string, params: parameters): string => {
  const queries = [];
  for (const param in params) {
    queries.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
  }
  return path + '?' + queries.join('&');
};

export const BuildRouteFromParameters = (path: string, params: parameters): string => {
  const queries = [];
  for (const param in params) {
    queries.push(encodeURIComponent(params[param]));
  }
  return path + '/' + queries.join('/');
};
